export function setupHomeInteractions() {
  const buttons = document.querySelectorAll<HTMLButtonElement>('.lh-film-play');
  buttons.forEach(button => { button.hidden = false; });
  const handleClick = (event: MouseEvent) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest<HTMLButtonElement>('.lh-film-play');
    if (button) {
      const video = button.parentElement?.querySelector('video');
      if (video) {
        button.hidden = true;
        video.focus();
        void video.play().catch(() => {
          // Native controls remain available when playback is blocked or fails.
          video.controls = true;
        });
      }
    }
    if (event.target.closest('.lh-mobile-menu a')) {
      document.querySelector<HTMLDetailsElement>('.lh-mobile-menu')?.removeAttribute('open');
    }
  };
  const handleKey = (event: KeyboardEvent) => {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector<HTMLDetailsElement>('.lh-mobile-menu[open]');
    if (menu) {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    }
  };
  document.addEventListener('click', handleClick);
  document.addEventListener('keydown', handleKey);
  return () => {
    document.removeEventListener('click', handleClick);
    document.removeEventListener('keydown', handleKey);
    buttons.forEach(button => { button.hidden = true; });
  };
}
